import { lazy } from "react";

const PROTECTED_ROUTES = [
  {
    key: "page.project_builder",
    path: "/project-builder",
    component: lazy(() => import("@/pages/ProjectBuilderPage")),
    meta: { index: true },
  },
  {
    key: "page.grant_application",
    path: "/programs/:id/apply",
    component: lazy(() => import("@/pages/GrantApplicationPage")),
    meta: { index: true },
  },
  {
    key: "page.reviews",
    path: "/reviews",
    component: lazy(() => import("@/pages/ReviewsPage")),
    meta: { index: true },
  },
  {
    key: "page.activity",
    path: "/activity",
    component: lazy(() => import("@/pages/ActivityPage")),
    meta: { index: true },
  },
  {
    key: "page.profile",
    path: "/profile",
    component: lazy(() => import("@/pages/ProfilePage")),
    meta: { index: true },
  },
  {
    key: "page.activities",
    path: "/activities",
    component: lazy(() => import("@/pages/ActivitiesPage")),
    meta: { index: true },
  },
  {
    key: "page.grant_application_details",
    path: "/programs/:id/application",
    component: lazy(() => import("@/pages/GrantApplicationDetailsPage")),
    meta: { index: true },
  },
  {
    key: "page.submit-review",
    path: "/reviews/:id",
    component: lazy(() => import("@/pages/SubmitReviewPage")),
    meta: { index: true },
  },
  // {
  //   key: "page.milestone",
  //   path: "/milestone/:id",
  //   component: lazy(() => import("@/pages/MilestonePage")),
  //   meta: { index: true },
  // },
  // {
  //   key: "page.referrals",
  //   path: "/referrals",
  //   component: lazy(() => import("@/pages/ReferralsPage")),
  //   meta: { index: true },
  // },
  {
    key: "page.submit-milestone",
    path: "/milestone/:id/submit",
    component: lazy(() => import("@/pages/SubmitMilestonePage")),
    meta: { index: true },
  },
  {
    key: "page.kyc-verification",
    path: "/kyc-verification",
    component: lazy(() => import("@/pages/KYCVerificationPage")),
    meta: { index: true },
  },
  {
    key: "page.guardians",
    path: "/guardians",
    component: lazy(() => import("@/pages/GuardianDashboardPage")),
    meta: { index: true },
  },
  {
    key: "page.guardians-apply",
    path: "/guardians/apply",
    component: lazy(() => import("@/pages/GuardianApplicationPage")),
    meta: { index: true },
  },
];

export default PROTECTED_ROUTES;
